module.exports = __webpack_public_path__ + "img/11825389_L.3681e6df.png";